<template>
  <div class="block-title-outer">
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  props:{
    title:String
  }
}
</script>

<style lang="scss" scoped>
.block-title-outer{
  width: 100%;
  border-bottom: 1px solid #4C84AD;
  .title{
    position: relative;
    height: 100%;
    color: var(--color);
    font-size: 17px;
    font-weight: bold;
    padding: 10px 0;
    letter-spacing: 3px;
    &::before{
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100px;
      height: 3px;
      background-color: var(--color);
    }
  }
}
</style>